module.exports = __webpack_public_path__ + "img/Default-M-3.96379a9f.svg";